import { AppBar, Avatar, Box, Button, Card, CardContent, IconButton, Toolbar, Typography, ThemeProvider } from '@mui/material'
import React, { useState } from 'react'
import { useMsal } from "@azure/msal-react";
import InctureLogo from '../../Assets/InctureLogo.png'
import './AppBarComponent.css'
import { useSelector } from 'react-redux';

function handleLogout(instance) {
  instance.logoutRedirect().catch(e => {
      console.error(e);
  });
}



const AppBarComponent = () => {
  
  const userReducer = useSelector((state) => state.userReducer);

 


  const toolbarStyle = {
    minHeight: '52px',
    paddingLeft: '15px'
  };

  const { instance } = useMsal();

  const [isMenuOpen, setIsMenuOpen] = useState(false);


  const renderMenu = (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				position: "absolute",
				top: 45,
				right: 10,
				zIndex: 10,
			}}
		>
			<Card variant='outlined'>
				<CardContent sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
					<Avatar sx={{height: '23px', width: '23px', fontSize: '14px' }}>{userReducer.avatarInitials}</Avatar>
					<Typography
						sx={{ fontSize: "16px" }}						
					>
						{userReducer.userData.name}
					</Typography>
					<Typography
						sx={{ fontSize: "14px" }}
					>
						{userReducer.userData.username}
					</Typography>
					<Button
						size='small'
						onClick={() => handleLogout(instance)}
					>
						Sign out
					</Button>
				</CardContent>
			</Card>
		</div>
	);

  

  return (
    // <Box sx={{ flexGrow: 1 }}>
      <AppBar
        sx={{
          bgcolor: "#fff",
          height: "52px"       
        }}
        position="sticky"
      >
        <Toolbar style={toolbarStyle}>
          <div className="incture-logo" onClick={() => window.open("https://incture.com", '_blank')}>
            <img
              src={InctureLogo}
              alt=" "
              height="38vh"
              width="auto"
            />
          </div>

          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <IconButton
              size="medium"
              edge="end"
              aria-label="account of current user"
              aria-haspopup="true"
              color="inherit"
              sx={{
                color: "#424242",
              }}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {/* <AccountCircle /> */}
              <Avatar sx={{height: '28px', width: '28px', fontSize: '14px', padding: '0'}}>
                {userReducer.avatarInitials}
              </Avatar>
            </IconButton>
            <div>{isMenuOpen ? <div>{renderMenu}</div> : null}</div>
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="medium"
              aria-label="show more"
              aria-haspopup="true"
              color="inherit"
            ></IconButton>
          </Box>
        </Toolbar>
      </AppBar>
    // </Box>
  );
}

export default AppBarComponent;